import { Alert, Box, Snackbar, Stack } from '@mui/material';
import { dismissNotification, useNotifications } from '../../state/notifications/notifications';
import { BrowserNotificationPermissionDialog } from './BrowserNotificationPermissionDialog';

const expiry = { short: 5000, long: 20000, persistent: null };

export const NotificationCenter = () => {
  const notifications = useNotifications();
  return (
    <>
      <Box sx={{ position: 'fixed', top: 24, left: 0, right: 0, zIndex: (theme) => theme.zIndex.snackbar, pointerEvents: 'none' }}>
        <Stack spacing={1} sx={{ alignItems: 'center' }}>
          {notifications.map(({ id, inAppText, inAppExpiry = 'short', status }) => (
            <Snackbar
              key={id}
              open
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              autoHideDuration={expiry[inAppExpiry]}
              onClose={(_, closeReason) => {
                if (closeReason !== 'clickaway') {
                  dismissNotification(id);
                }
              }}
              sx={{ position: 'static', transform: { xs: 'none', sm: 'none' }, pointerEvents: 'auto', maxWidth: '100%' }}
            >
              <Alert severity={status} variant="filled" onClose={() => dismissNotification(id)}>
                {inAppText}
              </Alert>
            </Snackbar>
          ))}
        </Stack>
      </Box>
      <BrowserNotificationPermissionDialog />
    </>
  );
};
